import { httpCreate } from './http';

const http = httpCreate('/srv/autoComment');

export const autoComment = {
	//获取配置详情
	getAutoConfig(activityId) {
		return http.get(`/config/detail/${activityId}`);
	},
	//添加自动发送评论配置
	addAutoConfig(data) {
		return http.post('/config/save', data);
	},
	//添加手动发送评论配置
	addhaldConfig(data) {
		return http.post('/addComment/single', data);
	},
	//编辑评论
	editComment(id, params) {
		return http.post(`content/update/${id}`, {}, { params });
	},
	//删除评论
	deletesComment(id) {
		return http.post(`/content/delete/${id}`);
	},
	//向评论库中添加评论
	addLibraryComment(data) {
		return http.post('/content/add', data);
	},
	//对应评论库 评论列表数据
	commentData(libraryId, params) {
		return http.get(`/content/list/${libraryId}`, { params });
	},
	//下拉评论库列表
	dropDownLibrary(activityId) {
		return http.get(`/library/list/${activityId}`);
	},
	//删除评论库
	deleteCommentLibrary(id) {
		return http.post(`library/delete/${id}`);
	},
	//编辑评论库
	editCommentLibrary(id, params) {
		return http.post(`/library/update/${id}`, {}, { params });
	},
	//添加评论库
	addCommentLibrary(data) {
		return http.post('/library/add', data);
	},
	//新版添加评论 data:['1','aaa']
	addCommentNew(libraryId, data) {
		return http.post(`/content/add-list/${libraryId}`, data);
	},
};
